function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var SingleSelect = /*#__PURE__*/function () {
  function SingleSelect(autocomplete) {
    _classCallCheck(this, SingleSelect);

    this.defaultValue = '';
    this.defaultText = '';
    this.autocomplete = autocomplete;
  }

  _createClass(SingleSelect, [{
    key: "connected",
    value: function connected() {
      var _a;

      this.defaultValue = this.hiddenField.value;
      this.defaultText = (_a = this.hiddenField.getAttribute('data-text')) !== null && _a !== void 0 ? _a : '';
    }
  }, {
    key: "start",
    value: function start() {
      if (this.selectedOption) {
        this.autocomplete.combobox.select(this.selectedOption);
        this.autocomplete.combobox.activate(this.selectedOption, {
          scroll: true
        });
      } else {
        var firstOption = this.autocomplete.visibleOptions[0];
        if (!firstOption) return;
        this.autocomplete.combobox.activate(firstOption, {
          scroll: true
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var text = this.hiddenField.dataset.text;
      this.autocomplete.input.value = text !== null && text !== void 0 ? text : '';
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setValue(this.defaultValue, this.defaultText);
    }
  }, {
    key: "select",
    value: function select(option) {
      var _a;

      var value = (_a = option.getAttribute('value')) !== null && _a !== void 0 ? _a : '';
      var text = option.dataset.text;
      this.setValue(value, text || '');
      this.autocomplete.hide();
    }
  }, {
    key: "setValue",
    value: function setValue(value, text) {
      this.hiddenField.value = value;
      var trimmedText = text.trim();
      this.hiddenField.setAttribute('data-text', trimmedText);
      this.autocomplete.input.value = trimmedText;
      this.autocomplete.toggleSelectedClass(!!value);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setValue('', '');
    }
  }, {
    key: "required",
    set: function set(value) {
      this.autocomplete.input.required = value;
    }
  }, {
    key: "selectedOption",
    get: function get() {
      var _this = this;

      return this.autocomplete.options.find(function (o) {
        return o.getAttribute('value') === _this.autocomplete.value;
      });
    }
  }, {
    key: "hiddenField",
    get: function get() {
      return this.autocomplete.querySelector('input[data-behavior="hidden-field"]');
    }
  }]);

  return SingleSelect;
}();

export { SingleSelect as default };